import { BooleanInput, SearchInput } from 'react-admin'

const PresetListFilters = [
    <SearchInput variant="outlined" placeholder="Search name" source="internal_name" alwaysOn />,
    <BooleanInput source="published" label="Published" variant="outlined" defaultValue={true} />
]

export default PresetListFilters
